import React, { useImperativeHandle, useRef, forwardRef } from "react";
import cx from "clsx";
import { Editor } from "@tinymce/tinymce-react";
import { INIT, INIT_MARKDOWN } from "./TextEditor.consts";
import "./TextEditor.scss";
import "./tinymce.css";

/**
 * @param {Object} param0
 * @param {string?} param0.value
 * @param {string?} param0.initialValue
 * @param {(value: string) => void} param0.onChange
 * @param {(_evt: unknown, editor: unknown) => void} param0.onInit
 * @param {string?} param0.className
 * @param {boolean?} param0.isDisabled
 * @param {RawEditorOptions?} param0.init
 * @param {boolean?} param0.markdownMode
 *
 */
export const TextEditor = forwardRef((props, ref) => {
  const {
    value,
    initialValue,
    onChange,
    onInit,
    className,
    isDisabled = false,
    init = {},
    markdownMode = false,
  } = props;
  const editorRef = useRef(null);
  const hasValueProp = Object.prototype.hasOwnProperty.call(props, "value");

  useImperativeHandle(ref, () => ({
    getEditor: () => editorRef.current,
    getHtml: () => editorRef.current?.getContent?.() || "",
    getText: () => {
      const tmp = document.createElement("div");
      tmp.innerHTML = editorRef.current?.getContent?.() || "";
      return tmp.textContent || "";
    },
    focus: () => editorRef.current?.focus?.(),
  }));

  const initConfig = markdownMode ? INIT_MARKDOWN : INIT;

  return (
    <div
      className={cx(
        "TextEditor-shared",
        {
          "TextEditor-shared__disabled": isDisabled,
        },
        className,
      )}
    >
      <Editor
        onInit={(evt, editor) => {
          editorRef.current = editor;
          onInit?.(evt, editor);
        }}
        {...(hasValueProp ? { value } : { initialValue })}
        onEditorChange={onChange}
        init={{
          ...initConfig,
          ...init,
        }}
      />
    </div>
  );
});
